import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  labelColor?: string;
  checked?: boolean;
}

export const Root = styled.div`
  z-index: 300;
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  background-color: rgba(0, 0, 0, 0.45);
`

export const BoxContainer = styled.div`
  position: relative;
  width: 591px;
  height: 346.5px;
  padding: 0px 0px 44.5px 0px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border-radius: 6px;
`

export const TitleContainer = styled.div`
  height: 82px;
  padding: 0px 31px 0px 31px;
  font-family: Roboto;
  font-size: 24px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #272727;
  background-color: rgba(18, 36, 66, 0.05);
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const LeftSide = styled.div`
`

export const Title = styled.div`
  padding: 0px 0px 0px 0px;
`

export const Content = styled.div`
  width: 100%;
  padding: 23px 0px 0px 0px;
  height: 326px;
  overflow-y: auto;
`

export const Text = styled.div`
  margin: 0px 49px 99px 31px;
  font-family: Roboto;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
`
export const Container = styled.div`
  padding: 0px 33px 97px 33px;
`

export const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`
export const Icon = styled.svg`
  fill: none;
  stroke: #204078;
  stroke-width: 2px;
`
export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  width: 23px;
  height: 21px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  opacity:-1;
`

export const StyledCheckbox = styled.div`
  display: inline-block;
  width: 23px;
  height: 21px;
  border-radius: 2px;
  border: solid 1px rgba(18, 36, 66, 0.2);
  background: ${(props: IRootProps) => props.checked ? '#ffffff' : '#fffffff'};
  transition: all 150ms;
  ${HiddenCheckbox}:focus + & {
    border-radius: 2px;
    border: solid 1px #122442;
  }
  ${Icon} {
    visibility: ${(props: IRootProps) => props.checked ? 'visible' : 'hidden'};
  }
`
export const Label = styled.label`
  margin-left: 15px; 
  font-size: 18px;
  font-weight: normal;
  color: #000000;;
`

export const ActionsContainer = styled.div`
  position: absolute;
  display: flex;
  right: 32px;
  bottom: 30px;
`

export const Error = styled.div`
  font-weight: bold;
  margin-right: 6px;
`

export const Action = styled.div`
  min-width: 112px;
`